import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { FaCheckCircle } from 'react-icons/fa'

function SwapSuccess() {
    const navigate = useNavigate()
    const location = useLocation()
    const swapDetails = location.state?.swapDetails;
    const transaction = location.state?.transaction;

    const isPayloadEmpty = !swapDetails;

    useEffect(() => {
        if (isPayloadEmpty) {
            navigate("/user/currency_swap", { replace: true });
        }
    }, [isPayloadEmpty, navigate]);

    const { sendCurrency, receiveCurrency, sendAmount, receiveAmount } = swapDetails || {};

    const handleTransactionDetails = () => {
        const refId = transaction?.reference || transaction?.ref_id || transaction?.id || swapDetails?.reference;
        if (refId) {
            navigate(`/user/transactions/${refId}`, { state: { transactionDetails: transaction } });
        } else {
            navigate('/user/transactions');
        }
    };
    return (
        <div>
            <div className="create__card__page send__money__page pt-2">

                <div className='auth__container__box mt-4 shadow-none rounded'>
                    <FaCheckCircle size={80} color="green" className="mb-4 d-flex justify-content-center mx-auto" />
                    <h3 className=''>Successful</h3>
        
                    <p className='auth__text '>
                        You have successfully swapped your money from  <b> {sendCurrency} {sendAmount} </b>
                        <br /> to
                    </p>

                    <h1 className='text-center my-2'>{receiveCurrency} {receiveAmount}</h1>

                    <button onClick={handleTransactionDetails} className='btn btn-primary w-100 mt-4'>
                        Transaction Details
                    </button>

                    <button onClick={() => navigate('/user/dashboard')}
                        className='btn btn-outline-light text-dark w-100 mt-3'
                    >
                        Go to Dashboard
                    </button>
                </div>


            </div>
        </div>
    )
}

export default SwapSuccess;